import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_EM_CATEGORY_LIST = "GET_EM_CATEGORY_LIST";

export const service = async (data) => {
  const options: object = {
    url: '/Api/Analytics/GetBellCurveReportParameterEmCategoryList',
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_EM_CATEGORY_LIST, service, mock);
